<template>
	<div class="min-h-screen flex flex-col">
		<!-- Main Content -->
		<main class="flex-grow">
			<RedNavMenu />
			<router-view></router-view>
			<Footer />
			<BackToTop />
		</main>
	</div>
</template>

<script setup>
import RedNavMenu from "@/components/layout/RedNavMenu.vue";
import Footer from "@/components/layout/Footer.vue";
import BackToTop from "@/components/common/BackToTop.vue";
</script>
